import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreLoginPeticion } from '../../../models/pre-login/PreLogin-peticion';
import { AutenticadorService } from 'src/app/services/autenticador/autenticador.service';
import { MatDialog } from '@angular/material';
import { DialogTokenSuscripcionComponent } from '../../dialogs/dialog-token-suscripcion/dialog-token-suscripcion.component';

@Component({
  selector: 'app-inicio-habiente',
  templateUrl: './inicio-habiente.component.html',
  styleUrls: ['./inicio-habiente.component.css']
})
export class InicioHabienteComponent implements OnInit {
  errorLogin: boolean;
  versionPortal: any;

  preLoginPeticion = new PreLoginPeticion();

  constructor(
    private autenticatorService: AutenticadorService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute) { }

  ngOnInit() {
    sessionStorage.clear();
    this.autenticatorService.callPreLogin(true);
  }

  crearCuenta() {
    this.router.navigate(['/crearcuentacorreo']);
  }
  acceso() {
    this.router.navigate(['/login']);
  }
  suscManExpress(){
    this.router.navigate(['/embeddedexpress']);
  }

  suscManComercio(){
    this.showDialogValidTokenSus('Aceptar suscripción', 'Valide el token de suscripción entregado por la empresa.', true);
  }
  showDialogValidTokenSus(pTitle: string, pContent: string, pShowBtnCancel: boolean) {
    const dialogRef = this.dialog.open(DialogTokenSuscripcionComponent, {
      data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed ' + result);
      if (result) {
         this.router.navigate(['/suscComercio'], { relativeTo: this.route });
      }else{
        sessionStorage.removeItem('tokenSessionSusComercio');
        sessionStorage.removeItem('listSusComercio');
      }
    });
  }

}
